import React, { useState } from "react";

const UserContext = React.createContext({
  userName: "",
  selectWordList: [],
  setUserName: () => {},
  setSelectWordList: () => {},
  API_KEY: "AIzaSyARblTbLpp4Ta0WMqTHhpCI7LwFBvVudjY",
});

export function UserContextProvider(props) {
  const [userName, setUserName] = useState("");
  const [selectWordList, setSelectWordList] = useState([]);

  return (
    <UserContext.Provider
      value={{
        userName,
        setUserName,
        selectWordList,
        setSelectWordList,
        API_KEY: "AIzaSyARblTbLpp4Ta0WMqTHhpCI7LwFBvVudjY",
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
}

export default UserContext;
